import {
  getResource,
  SUB_LINE_ITEM_RESOURCE
} from "shared/actions/actionLocator";
import { get } from "lodash";
import { SectionCompletedResource } from "./localTableResource";

export const dispatchEventAction = (dispatch, event) => {
  if (get(event, "type") === "sectionCompleted") {
    return new SectionCompletedResource(dispatch).put(
      event.payload.value,
      true
    );
  }
  if (get(event, "type") === "autoSelectOptions") {
    const LineItemResource = getResource(SUB_LINE_ITEM_RESOURCE);
    const resource = new LineItemResource(dispatch, event.payload.unitId);
    return resource.selectProducts(event.payload.selection);
  }
  return Promise.resolve();
};
